import { render, staticRenderFns } from "./ProfileTalentPackagesListItemOption.vue?vue&type=template&id=4ad7a1e8&scoped=true"
import script from "./ProfileTalentPackagesListItemOption.vue?vue&type=script&lang=js"
export * from "./ProfileTalentPackagesListItemOption.vue?vue&type=script&lang=js"
import style0 from "./ProfileTalentPackagesListItemOption.vue?vue&type=style&index=0&id=4ad7a1e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad7a1e8",
  null
  
)

export default component.exports